// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';
import { dispatchEvent } from '../dispatch-event/dispatch-event.tsx';

export const closeCurrentTask =
	(): Action<State> =>
	({ setState, dispatch }) => {
		setState({ openTaskId: null });
		dispatch(dispatchEvent({ type: 'opened-task-change', taskId: null }));
	};
